import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Divider,
  Paper,
  Chip,
  Button,
  Grid,
  TextField,
  InputAdornment,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import {
  Close,
  ArrowBack,
  Edit,
  Delete,
  PriorityHigh,
  AccessTime,
  Person,
  Info,
  Search,
  QueuePlayNext,
} from "@mui/icons-material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Overlay } from "../../styles/global";
import { PapiroConsole } from "src/utils/papiroConsole";
import SearchIcon from "@mui/icons-material/Search";
import DOMPurify from "dompurify";
import moment from "moment";
import CalledAttachments from "src/pages/called-view/components/tabs/called-attachments";

const DayDetailModal = ({
  open,
  onClose,
  selectedDay,
  selectedTicket,
  onTicketClick,
  onBackToList,
  paginationInfo,
  onLoadMore,
  getStatusColor,
  getPriorityColor,
  onEditTicket,
  onDeleteTicket,
  searchTerm,
  onSearchChange,
  consultCalled,
  trackCalled,
  setMessage,
  setLoading,
  createCalled,
  renderedList,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // if (!selectedDay) return null;

  // const { day, month, year, tickets } = selectedDay;

  const {
    day = null,
    month = null,
    year = null,
    tickets = [],
  } = selectedDay || {};

  PapiroConsole.log("tickets here");
  PapiroConsole.log(tickets);
  const formattedDate =
    day && month && year
      ? `${day < 10 ? "0" + day : day}/${
          month < 10 ? "0" + month : month
        }/${year}`
      : null;

  // Obter status para legendas
  // const statuses = [...new Set(tickets.map((t) => t.status))];
  const statuses = [
    ...new Map(tickets.map((t) => [t.status?.name, t.status])).values(),
  ];
  PapiroConsole.log("statuses here");
  PapiroConsole.log(statuses);

  function stripHtmlTags(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  // Renderiza a lista de tickets
  const renderTicketsList = () => {
    const {
      visibleTickets = [],
      hasMore = false,
      totalCount = 0,
      filteredCount = 0,
    } = paginationInfo || {};
    PapiroConsole.log("visibleTickets");
    PapiroConsole.log(visibleTickets);

    const isFiltering = searchTerm && searchTerm.trim() !== "";
    const displayCount = isFiltering
      ? `${filteredCount} de ${totalCount}`
      : totalCount;

    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {visibleTickets && visibleTickets.length > 0 && (
          <Box sx={{ mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Tickets para {formattedDate ? formattedDate : ""}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {displayCount} ticket{totalCount !== 1 ? "s" : ""}
              </Typography>
            </Box>

            {/* Campo de Pesquisa */}
            <TextField
              placeholder="Pesquisar chamados..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              fullWidth
              variant="outlined"
              size="small"
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
            />

            {/* Legendas de status */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
              {statuses.map((status) => (
                <Box
                  key={status.id}
                  sx={{ display: "flex", alignItems: "center", mr: 2 }}
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor:
                        status && status.colorhex ? status.colorhex : "#ccc",
                      mr: 1,
                    }}
                  />
                  <Typography variant="caption">{status.name}</Typography>
                </Box>
              ))}
            </Box>

            <Divider />
          </Box>
        )}

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {visibleTickets.length > 0 ? (
            <>
              <Grid container spacing={2} sx={{ mb: 2, width: "100%", mx: 0 }}>
                {visibleTickets.map((ticket) => (
                  <Grid item xs={12} key={ticket.id}>
                    <Paper
                      elevation={1}
                      sx={{
                        p: 2,
                        borderLeft: `4px solid ${
                          ticket.status && ticket.status.colorhex
                            ? ticket.status.colorhex
                            : "#ccc"
                        }`,
                        cursor: "pointer",
                        transition: "all 0.2s",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: 2,
                        },
                      }}
                      onClick={() => onTicketClick(ticket)}
                    >
                      {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                          {ticket.title}
                        </Typography>
                        <Tooltip title={<h5>Acompanhar chamado</h5>}>
                          <IconButton aria-label="table-popup" onClick={() => trackCalled(ticket.id)} >
                            <QueuePlayNext />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={<h5>Consultar chamado</h5>}>
                          <IconButton aria-label="table-popup" onClick={() => consultCalled(ticket.id)} >
                            <SearchIcon />
                          </IconButton>
                        </Tooltip>

                        <Chip
                          label={ticket.priority ? ticket.priority.name : 'default'}
                          size="small"
                          color={getPriorityColor(ticket.priority ? ticket.priority.name : 'default')}
                          icon={<PriorityHigh />}
                        />
                      </Box> */}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 1,
                        }}
                      >
                        {/* Título alinhado à esquerda */}
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "medium" }}
                        >
                          {ticket.title}
                        </Typography>

                        {/* Demais elementos alinhados à direita */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Tooltip title={<h5>Acompanhar chamado</h5>}>
                            <IconButton
                              aria-label="table-popup"
                              onClick={() => trackCalled(ticket.id)}
                            >
                              <QueuePlayNext />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={<h5>Consultar chamado</h5>}>
                            <IconButton
                              aria-label="table-popup"
                              onClick={() => consultCalled(ticket.id)}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>

                          <Chip
                            label={
                              ticket.priority ? ticket.priority.name : "default"
                            }
                            size="small"
                            // color={getPriorityColor(ticket.priority ? ticket.priority.name : 'default')}

                            sx={{
                              backgroundColor:
                                ticket.priority && ticket.priority.colorhex
                                  ? ticket.priority.colorhex
                                  : "#ccc",
                              color: "#fff", // ou qualquer cor de texto que você quiser
                            }}
                            // icon={<PriorityHigh />}
                          />
                        </Box>
                      </Box>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        {(() => {
                          const desc =
                            ticket.descriptiontext &&
                            ticket.descriptiontext.length > 0
                              ? ticket.descriptiontext
                              : ticket.description || "";

                          const cleanText = stripHtmlTags(desc);

                          return cleanText.length > 100
                            ? `${cleanText.substring(0, 100)}...`
                            : cleanText;
                        })()}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Person
                            fontSize="small"
                            color="action"
                            sx={{ mr: 0.5 }}
                          />
                          <Typography variant="caption" color="text.secondary">
                            {ticket.requestinguser && ticket.requestinguser.name
                              ? "Solicitante: " + ticket.requestinguser.name
                              : ""}
                          </Typography>
                        </Box>
                        <Typography variant="caption" color="text.secondary">
                          ID: #{ticket.id}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {ticket.assigneduser && ticket.assigneduser.name && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Person
                              fontSize="small"
                              color="action"
                              sx={{ mr: 0.5 }}
                            />
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {ticket.assigneduser && ticket.assigneduser.name
                                ? "Responsável: " + ticket.assigneduser.name
                                : ""}
                            </Typography>
                          </Box>
                        )}

                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <DateRangeIcon fontSize="small" sx={{ mr: 0.5 }} />
                          Data de Previsão de solução:{" "}
                          {ticket.duedate
                            ? moment(ticket.duedate).format(
                                "DD/MM/YYYY HH:mm:ss"
                              )
                            : ""}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>

              {hasMore && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: "auto",
                    pb: 2,
                  }}
                >
                  <Button onClick={onLoadMore} variant="outlined">
                    Carregar mais tickets (+10)
                  </Button>
                </Box>
              )}
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
                p: 3,
              }}
            >
              {searchTerm && searchTerm.trim() !== "" ? (
                <>
                  <Typography variant="body1" color="text.secondary">
                    Nenhum chamado encontrado para a pesquisa "{searchTerm}".
                  </Typography>
                  <Button
                    variant="outlined"
                    sx={{ mt: 2 }}
                    onClick={() => onSearchChange("")}
                  >
                    Limpar Pesquisa
                  </Button>
                </>
              ) : (
                <>
                  {renderedList && (
                    <>
                      <Typography variant="body1" color="text.secondary">
                        Nenhum chamado encontrado para esta data.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={() => createCalled()}
                      >
                        Criar Ticket
                      </Button>
                    </>
                  )}
                  {/* <Typography variant="body1" color="text.secondary">
                    Nenhum chamado encontrado para esta data.
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{ mt: 2 }}
                    onClick={() => createCalled()}
                  >
                    Criar Ticket
                  </Button> */}
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const formatDate = (isoString) => {
    const date = moment(isoString);

    if (!date.isValid()) {
      return isoString; // retorna o valor original se for inválido
    }

    return date.format("DD/MM/YYYY [às] HH:mm");
  };

  // Renderiza os detalhes de um ticket específico
  const renderTicketDetails = () => {
    if (!selectedTicket) return null;

    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <IconButton onClick={onBackToList} sx={{ mr: 1 }}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h6">Detalhes do Ticket</Typography>
          </Box>

          <Divider />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            pr: 0.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              mb: 2,
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: "bold", mb: 1 }}>
              {selectedTicket.title}
            </Typography>

            <Box>
              <Chip
                label={
                  selectedTicket.status && selectedTicket.status.name
                    ? selectedTicket.status.name
                    : "default"
                }
                sx={{
                  bgcolor:
                    selectedTicket.status && selectedTicket.status.colorhex
                      ? selectedTicket.status.colorhex
                      : "#ccc",
                  color: "white",
                  fontWeight: "bold",
                  mr: 1,
                }}
              />
              <Chip
                label={
                  selectedTicket.priority
                    ? selectedTicket.priority.name
                    : "default"
                }
                // color={getPriorityColor(selectedTicket.priority ? selectedTicket.priority.name : 'default')}
                sx={{
                  bgcolor:
                    selectedTicket.priority && selectedTicket.priority.colorhex
                      ? selectedTicket.priority.colorhex
                      : "#ccc",
                  color: "white",
                  fontWeight: "bold",
                  mr: 1,
                }}
                // icon={<PriorityHigh sx={{ color:'white'}} />}
              />
            </Box>
          </Box>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Person fontSize="small" color="action" sx={{ mr: 1 }} />
              <Typography variant="body2">
                <strong>Solicitante:</strong>{" "}
                {selectedTicket.requestinguser &&
                selectedTicket.requestinguser.name
                  ? selectedTicket.requestinguser.name
                  : ""}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <AccessTime fontSize="small" color="action" sx={{ mr: 1 }} />
              <Typography variant="body2">
                <strong>Data prevista:</strong>{" "}
                {formatDate(selectedTicket.duedate)}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Info fontSize="small" color="action" sx={{ mr: 1 }} />
              <Typography variant="body2">
                <strong>ID:</strong> #{selectedTicket.id}
              </Typography>
            </Box>

            <Box
              sx={{ display: "flex", alignItems: "center", marginLeft: "auto" }}
            >
              {/* <Info fontSize="small" color="action" sx={{ mr: 1 }} />
              <Typography variant="body2">
                <strong>ID:</strong> #{selectedTicket.id}
              </Typography> */}
              <Tooltip title={<h5>Acompanhar chamado</h5>}>
                <IconButton
                  aria-label="table-popup"
                  onClick={() => trackCalled(selectedTicket.id)}
                >
                  <QueuePlayNext />
                </IconButton>
              </Tooltip>
              <Tooltip title={<h5>Consultar chamado</h5>}>
                <IconButton
                  aria-label="table-popup"
                  onClick={() => consultCalled(selectedTicket.id)}
                >
                  <SearchIcon />
                </IconButton>
              </Tooltip>
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
              
            </Box> */}
          </Box>
          {selectedTicket.assigneduser && (
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "medium", mb: 1 }}
              >
                Atribuído para:
              </Typography>
              <Typography variant="body1">
                {selectedTicket.assigneduser.name}
              </Typography>
            </Box>
          )}

          <Typography variant="subtitle1" sx={{ fontWeight: "medium", mb: 1 }}>
            Descrição:
          </Typography>

          {/* <Paper sx={{ p: 2, bgcolor: '#f9fafb', mb: 3 }}>
            <Typography variant="body1">
              {selectedTicket.description}
            </Typography>
          </Paper> */}
          <Paper sx={{ p: 2, bgcolor: "#f9fafb", mb: 3 }}>
            <Typography variant="body1">
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  whiteSpace: "pre-wrap",
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(selectedTicket.description || ""),
                }}
              />
            </Typography>
          </Paper>

          <Typography variant="subtitle1" sx={{ fontWeight: "medium", mb: 1 }}>
            Anexos:
          </Typography>

          {/* <Paper sx={{ p: 2, bgcolor: '#f9fafb', mb: 3 }}>
            <Typography variant="body1">
              {selectedTicket.description}
            </Typography>
          </Paper> */}
          <Paper sx={{ p: 2, bgcolor: "#f9fafb", mb: 3 }}>
            <CalledAttachments
              calledData={selectedTicket}
              // setMessage={props.setMessage}
              setMessage={setMessage}
              setLoading={setLoading}
            />
          </Paper>

          <Box sx={{ display: "flex", gap: 2, mt: 2, mb: 2 }}>
            {/* <Button
              variant="contained"
              startIcon={<Edit />}
              onClick={() => {
                onEditTicket(selectedTicket);
                onClose();
              }}
            >
              Editar Chamado
            </Button> */}
            {/* <Button 
              variant="outlined" 
              color="error"
              startIcon={<Delete />}
              onClick={() => {
                if (window.confirm('Tem certeza que deseja excluir este ticket?')) {
                  onDeleteTicket(selectedTicket.id);
                }
              }}
            >
              Excluir Ticket
            </Button> */}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          height: "calc(100% - 64px)", // Ajuste da altura para evitar espaço em branco
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
          flexShrink: 0, // Impedir que o título encolha
        }}
      >
        {!selectedTicket ? (
          <>
            {day && month && year && (
              <Typography variant="h6">
                {day} de{" "}
                {
                  [
                    "Janeiro",
                    "Fevereiro",
                    "Março",
                    "Abril",
                    "Maio",
                    "Junho",
                    "Julho",
                    "Agosto",
                    "Setembro",
                    "Outubro",
                    "Novembro",
                    "Dezembro",
                  ][month - 1]
                }{" "}
                de {year}
              </Typography>
            )}
          </>
        ) : (
          <Typography variant="h6">Ticket #{selectedTicket.id}</Typography>
        )}
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 3,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden", // Remover scroll do DialogContent
        }}
      >
        {selectedTicket ? renderTicketDetails() : renderTicketsList()}
      </DialogContent>
    </Dialog>
  );
};

export default DayDetailModal;
